import React from 'react';
import SelectField from './../Form/SelectField';

const FormP18T1 = React.memo((props) => {
    const handleNotesChanges = (event) => {
        props.setNotes(event.target.value);
    };

    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '10', label: '10 pads' },
                    { value: '25', label: '25 pads' },
                    { value: '50', label: '50 pads' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> VATS and Lobectomy Surgery Notepad</div>
                <div className="description mt-3">
                    <span className="label">Description:</span> A full-sized notepad featuring illustrations of the lung that can be used for educational purposes.
                </div>
                <div className="description-list">
                    <span className="label">Detail:</span>
                    <ul>
                        <li>8.5" w x 11" uncoated paper</li>
                        <li>Double-sided print</li>
                        <li>25 sheets per pad, with glue and cardboard backing</li>
                        <li>80# Cover, Classic Crest, Avalanche White (medium thickness)</li>
                        <li>Variable data printing not available</li>
                        <li>Available in color only</li>
                        <li>Last updated on 6-02-21</li>
                    </ul>
                </div>
            </div>
            <div className="notes-container">
                <b>Notes:</b>
                <textarea value={props.notes} onChange={handleNotesChanges} />
            </div>
            <h5>Pricing</h5>
            <div className="pricing-container">
                <table className="table table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <th className="text-right">Quantity</th>
                            <th className="text-right">Price</th>
                            <th className="text-right">Each</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-right">10</td>
                            <td className="text-right">$130.00</td>
                            <td className="text-right">$13.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">25</td>
                            <td className="text-right">$277.00</td>
                            <td className="text-right">$11.08</td>
                        </tr>
                        <tr>
                            <td className="text-right">50</td>
                            <td className="text-right">$518.00</td>
                            <td className="text-right">$10.36</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
    );
});

export default FormP18T1;
